import React from 'react'
import {useStyles} from "./ChallengedDecisionStatusIndication.css";
import {useIntl} from "react-intl";

const ChallengedDecisionStatusIndication = ({isClosed}) => {
    const classes = useStyles()

    // Internationalization for simple strings
    const intl = useIntl();

    const status = isClosed ? 'closed' : 'open'

    return <div className={classes[status]}>
        {intl.formatMessage({
            id: `app.ids.challengedDecisionStatus.${status}`,
            defaultMessage: status
        })}
    </div>
}
export default ChallengedDecisionStatusIndication
